// @flow
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { reduxForm } from 'redux-form';
import ValidationService from '../../../../lib/validation';
import type { StateProps } from './ResetPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import { isLoadingSelector } from '../../../../modules/LoadingStatus/reducer';
import { resetPassword } from '../../../../modules/Authentication';

const validate = values => ({
  email: ValidationService.validateEmail(values.email),
});

const mapStateToProps = (state): StateProps => ({
  isResettingPassword: isLoadingSelector(state, 'resetPassword'),
});

const mapDispatchToProps = {
  onSubmit: resetPassword,
};

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), reduxForm({ form: 'resetPassword', validate }));
export default enhance(ResetPasswordForm);
